import {DataIssuesArray, FilterIssue} from '@/models/Issue'
import {DataProductsArray, FilterProduct} from '@/models/Product'

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        $user: {
            id: 0,
            nickname: '',
            name: '',
            role: 20,
            department: '',
            employee_code: '',
            theme: 0,
            picture: null,
            signature: null,
            unread_notifications: 0,
        },
        intended: null,
        need_register_line: false,
        dialog_line: false,
        dialog: {
            customer: false,
            order: false,
            product: false,
            item: false,
            sales: false,
        },
        products: {
            response: new DataProductsArray(),
            data: new DataProductsArray().data,
            filter: new FilterProduct(),
            current: 0,
            scrollY: 0,
            sort: 'code',
            display: 'list',
        },
        issue: {
            response: new DataIssuesArray(),
            data: new DataIssuesArray().data,
            filter: new FilterIssue(),
            summary: {},
            current: 0,
            scrollY: 0,
            sort: 'status',
            display: 'list',
            dateFrom: '1970-01-01',
            dateTo: '1970-01-01',
        },

        items: {
            current_index: 0,
        },
        config: {
            business_type_price: {},
        },

    },
    mutations: {
        current_user(state, user) {
            state.$user = user
        },
        products_scrollY(state, y) {
            state.products.scrollY = y
        },

        issue_scrollY(state, y) {
            state.issue.scrollY = y
        },


        products_pageOption(state, {y, sort, display}) {
            state.products.scrollY = y
            state.products.sort = sort
            state.products.display = display
        },
        issue_pageOption(state, {y, sort, display}) {
            state.issue.scrollY = y
            state.issue.sort = sort
            state.issue.display = display
        },


        product_current(state, delta) {
            state.products.current = (state.products.current + delta) % state.products.response.data.length
            if (state.products.current < 0)
                state.products.current += state.products.response.data.length
        },
        products_response(state, response) {
            state.products.response = response
            state.products.data = state.products.response.data
            state.products.filter = state.products.response.filter
            state.products.current = 0
        },
        products_append(state, response: DataProductsArray) {
            state.products.response.links.next = response.links.next
            state.products.response.data.push(...response.data)
            state.products.current = 0
            // debugger
        },


        issue_current(state, delta) {
            state.issue.current = (state.issue.current + delta) % state.issue.response.data.length
            if (state.issue.current < 0)
                state.issue.current += state.issue.response.data.length
        },

        issue_response(state, response) {
            state.issue.response = response
            state.issue.data = state.issue.response.data
            state.issue.filter = state.issue.response.filter
            state.issue.summary = state.issue.response.summary
            state.issue.current = 0
        },
        issue_append(state, response: DataIssuesArray) {
            state.issue.response.links.next = response.links.next
            state.issue.response.data.push(...response.data)
            state.issue.current = 0
            // debugger
        },
        issue_update(state, {index, issue}) {
            // debugger
            state.issue.response.data[index] = issue

            // debugger
        },

        config(state, data) {
            state.config = data
        },
    },
    actions: {
        //customer_current(context, delta) {
        //context.commit('customer_current', delta)
        /// let customer: Customer = context.state.customers.data[context.state.customers.current]
        //console.log(customer)
        //},


    },
    modules: {},
})

